// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__EzmG6","title":"style__title__UyQcD","description":"style__description__CA-pQ","component":"style__component__y56dh"};